// extracted by mini-css-extract-plugin
export var content = "_ch-3";
export var list = "_ch-4";
export var settingsContent = "_ch-7";
export var settingsPanel = "_ch-8";
export var state = "_ch-6";
export var triggerBadge = "_ch-2";
export var triggerButton = "_ch-1";
export var triggerShell = "_ch-0";
export var unreadDot = "_ch-5";